/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Soft_Lynx_RestInputs */

const en_keen_soft_lynx_rest = /** @type {(inputs: Keen_Soft_Lynx_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Answers`)
};

const de_keen_soft_lynx_rest = /** @type {(inputs: Keen_Soft_Lynx_RestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestantworten`)
};

/**
* | output |
* | --- |
* | "Minimum Answers" |
*
* @param {Keen_Soft_Lynx_RestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_soft_lynx_rest = /** @type {((inputs?: Keen_Soft_Lynx_RestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Soft_Lynx_RestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_soft_lynx_rest(inputs)
	return de_keen_soft_lynx_rest(inputs)
});